import { SEND_CMD_CREDENTIALS_URL, VALIDATE_OTP_URL } from './consts';

import axios from 'axios';

const BASE_TSP_URL = window.TSP_URL || process.env.VUE_APP_BASE_TSP_URL;

const state = {
  step: 1,
  status: '',
  hasLoadedOnce: false,
  hasIdentities: false,
  mobileNumberEncrypted: null,
  mobileNumber: null,
  pinEncrypted: null,
};

const getters = {
  step: (state) => state.step,
  hasIdentities: (state) => state.hasIdentities,
};

const actions = {
  VALIDATE_OPT: ({ commit, rootState }, { otpCode, isEncrypted = false }) => {
    console.log('Action VALIDATE_OPT');
    const params = new URLSearchParams();
    params.append('code', otpCode);
    params.append('isEncrypted', isEncrypted);
    params.append('qestsp_signing_session', rootState.session_id_tsp);

    return new Promise((resolve, reject) => {
      axios
        .post(BASE_TSP_URL + VALIDATE_OTP_URL, params)
        .then((res) => {
          console.log(res);
          if (res.error) {
            reject(res.error);
          }
          if (res.data?.data.envelopeID) {
            var envelopeID = res.data.data.envelopeID;
            commit('envelopeID', envelopeID, { root: true });
          }
          if (res.data?.data.documents) {
            var documents = res.data.data.documents;
            commit('documents', documents, { root: true });
          }
          if (res.data?.data.redirectionURL) {
            var redirectUrl = res.data.data.redirectionURL;
            commit('redirectUrl', redirectUrl, { root: true });
            resolve(redirectUrl);
          }
        })
        .catch((error) => {
          const err = error.response;
          console.error(err);

          const errorMsg = {};

          errorMsg['event'] = 'response_error';
          errorMsg['event_category'] = 'error_complete_qes';

          if (err?.status == 401) {
            // GA Event Error
            errorMsg['event_label'] = 'session_expired';
            errorMsg['type'] = 'banner';
            errorMsg['message'] = 'expired';
          } else if (err?.data?.error?.status?.Code == 802) {
            // GA Event Error
            errorMsg['event_label'] = 'incorrect_code';
            errorMsg['type'] = 'otpCode';
            errorMsg['message'] = 'incorrectCode';
          } else if (err?.data?.error?.status?.Code == 816) {
            // GA Event Error
            errorMsg['event_label'] = 'expired_code';
            errorMsg['type'] = 'banner';
            errorMsg['message'] = 'expiredOtp';
          }else {
            // GA Event Error
            errorMsg['event_label'] = 'failed_signature';
            errorMsg['type'] = 'banner';
            errorMsg['message'] = 'failedsignature';
          }
          reject(errorMsg);

          // if (err.response && err.response.status == 401) {
          //   reject(err);
          // } else {
          //   reject((err.response && err.response.data) || err);
          // }
        });
    });
  },

  SEND_CMD_CREDENTIALS: (
    { rootState },
    { pin, number, isEncrypted = false }
  ) => {
    console.log('Action SEND_CMD_CREDENTIALS', SEND_CMD_CREDENTIALS_URL);

    return new Promise((resolve, reject) => {
      const params = new URLSearchParams();
      params.append('pin', pin);
      params.append('user_id', number);
      params.append('isEncrypted', isEncrypted);
      params.append('qestsp_signing_session', rootState.session_id_tsp);

      axios
        .post(BASE_TSP_URL + SEND_CMD_CREDENTIALS_URL, params)
        .then((res) => {
          console.log(res);
          if (!res) {
            reject(null);
          }
          resolve(res);
        })
        .catch((error) => {
          const err = error.response;
          console.error(err);

          const errorMsg = {};

          errorMsg['event'] = 'response_error';
          errorMsg['event_category'] = 'error_start_qes';

          if (err?.status == 401) {
            // GA Event Error
            errorMsg['event_label'] = 'session_expired';
            errorMsg['type'] = 'banner';
            errorMsg['message'] = 'expired';
          } else if (err?.status == 400) {
            // GA Event Error
            errorMsg['event_label'] = 'missing_parameter';
          } else if (err?.status == 415) {
            // GA Event Error
            errorMsg['event_label'] = 'invalid_certificates';
            errorMsg['message'] = 'invalidCertificates';
          }else {
            // GA Event Error
            errorMsg['event_label'] = err?.data?.message;
            errorMsg['type'] = 'mobileNumber';
            errorMsg['message'] = 'noCMD';
          }

          reject(errorMsg);
        });
    });
  },
};

const mutations = {
  step: (state, value) => {
    state.step = value;
  },
  hasIdentities: (state, value) => {
    state.hasIdentities = value;
  },
  mobileNumberEncrypted: (state, value) => {
    state.mobileNumberEncrypted = value;
  },

  mobileNumber: (state, value) => {
    state.mobileNumber = value;
  },
  pinEncrypted: (state, value) => {
    state.pinEncrypted = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
